<template lang="html">
    <div class="top-nav">
        <div class="lang_logout">
            <div v-if="urlBackToPortal" class="back-to-portal">
                <a :href="urlBackToPortal">Retour au portail</a>
            </div>
            <div
                v-popover:popoverUser
                class="user-options"
            >
                <i
                    class="el-icon-user-solid"
                    @click="menuSelected = ''"
                ></i>
                <el-popover
                    ref="popoverUser"
                    placement="bottom"
                    class="popover"
                    width="350"
                    trigger="click"
                >
                    <div
                        v-if="menuSelected === ''"
                        class="password-change menu-item"
                        @click="menuSelected = 'reset'"
                    >{{getText('menu_form_reset_password')}}</div>
                    <div v-else-if="menuSelected === 'reset'">
                        <form-reset-password
                            @resetResetForm="() => {this.menuSelected = ''}"
                        ></form-reset-password>
                    </div>
                </el-popover>
            </div>
            <el-select class="langage" v-model="langage" :placeholder="getLangage" size="mini" @change="changeLangage()">
                <el-option
                    v-for="langage in langages"
                    :key="langage"
                    :label="langage"
                    :value="langage"
                ></el-option>
            </el-select>

<!--                 <el-button class="greenButton logout" @click="logout()">{{getText('log_out')}}</el-button>
 -->                <svg @click="logout()" class="logout" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="475.085px" height="475.085px" viewBox="0 0 475.085 475.085" style="enable-background:new 0 0 475.085 475.085;" xml:space="preserve">
                <g>
                    <g>
                        <path d="M237.545,255.816c9.899,0,18.468-3.609,25.696-10.848c7.23-7.229,10.854-15.799,10.854-25.694V36.547    c0-9.9-3.62-18.464-10.854-25.693C256.014,3.617,247.444,0,237.545,0c-9.9,0-18.464,3.621-25.697,10.854    c-7.233,7.229-10.85,15.797-10.85,25.693v182.728c0,9.895,3.617,18.464,10.85,25.694    C219.081,252.207,227.648,255.816,237.545,255.816z"></path>
                        <path d="M433.836,157.887c-15.325-30.642-36.878-56.339-64.666-77.084c-7.994-6.09-17.035-8.47-27.123-7.139    c-10.089,1.333-18.083,6.091-23.983,14.273c-6.091,7.993-8.418,16.986-6.994,26.979c1.423,9.998,6.139,18.037,14.133,24.128    c18.645,14.084,33.072,31.312,43.25,51.678c10.184,20.364,15.27,42.065,15.27,65.091c0,19.801-3.854,38.688-11.561,56.678    c-7.706,17.987-18.13,33.544-31.265,46.679c-13.135,13.131-28.688,23.551-46.678,31.261c-17.987,7.71-36.878,11.57-56.673,11.57    c-19.792,0-38.684-3.86-56.671-11.57c-17.989-7.71-33.547-18.13-46.682-31.261c-13.129-13.135-23.551-28.691-31.261-46.679    c-7.708-17.99-11.563-36.877-11.563-56.678c0-23.026,5.092-44.724,15.274-65.091c10.183-20.364,24.601-37.591,43.253-51.678    c7.994-6.095,12.703-14.133,14.133-24.128c1.427-9.989-0.903-18.986-6.995-26.979c-5.901-8.182-13.844-12.941-23.839-14.273    c-9.994-1.332-19.085,1.049-27.268,7.139c-27.792,20.745-49.344,46.442-64.669,77.084c-15.324,30.646-22.983,63.288-22.983,97.927    c0,29.697,5.806,58.054,17.415,85.082c11.613,27.028,27.218,50.34,46.826,69.948c19.602,19.603,42.919,35.215,69.949,46.815    c27.028,11.615,55.388,17.426,85.08,17.426c29.693,0,58.052-5.811,85.081-17.426c27.031-11.604,50.347-27.213,69.952-46.815    c19.602-19.602,35.207-42.92,46.818-69.948s17.412-55.392,17.412-85.082C456.809,221.174,449.16,188.532,433.836,157.887z"></path>
                    </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                </svg>
        </div>
        <div class="row">
            <div class="logos">
                <div class="col3">
                    <router-link :to="{ name: 'home' }">
                        <div class="edf-logo">
                            <img src="/static/img/edf.svg" alt="">
                        </div>
                    </router-link>
                </div>
                <div class="col3">
                    <router-link :to="{ name: 'home' }">
                        <h1 class="app-title">Viveco</h1>
                    </router-link>
                </div>
            </div>
            <div class="linksV2">
                <router-link :to="{ name: 'home' }">
                    <el-button>{{getText('home')}}</el-button>
                </router-link>
                <router-link :to="{ name: 'sites' }">
                    <el-button>{{getText('my_sites')}}</el-button>
                </router-link>
                <router-link :to="{ name: 'simulations' }">
                    <el-button>
                        {{getText('my_simulations')}}
                    </el-button>
                </router-link>

                <ns-loader
                    :toLoad="toLoad"
                    style="display: inline;"
                    class="history-loader ns-loader"
                    @dataFetched="onDataFetched"
                >
                    <i slot="loader" class="el-icon-loading"></i>
                    <div slot="content">
                        |
                        <el-button
                            type="text"
                            class="history-button"
                            @click="openHistoryModal"
                        >
                            {{ getText('history_title') }}
                        </el-button>
                    </div>
                </ns-loader>
            </div>
        </div>
        <el-dialog
            :title="getText('history_modal_title')"
            :visible.sync="displayHistoryModal"
            class="history-dialog"
            @close="closeHistoryModal"
        >
            <HistoryModal
                v-if="displayHistoryModal"
                :simulation-usages="simulationUsages"
                @close="closeHistoryModal"
            ></HistoryModal>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import formResetPassword from './formResetPassword.vue';
import HistoryModal from './historyModal.vue';
import nsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
export default {
    data() {
        return {
            langages: ['en', 'fr'],
            langage: this.getLangage,
            menuSelected: '',
            displayHistoryModal: false,
            simulationUsages: []
        };
    },
    components: {
        formResetPassword,
        nsLoader,
        HistoryModal
    },
    computed: {
        ...mapGetters([
            'getText',
            'getLangage',
            'currentUser'
        ]),
        urlBackToPortal(){
            return window.config.master_page_url;
        },
        toLoad() {
            return [
                {
                    model: 'simulationUsages',
                    name: 'simulationUsages',
                    filters: {
                        user_uid: this.currentUser.uid
                    }
                },
            ]
        },
    },
    methods: {
        onDataFetched(data) {
            this.$set(this, 'simulationUsages', data.simulationUsages);
        },
        changeLangage() {
            this.$forceUpdate();
            moment.locale(this.langage);
            this.$store.commit('CHANGE_LANGAGE', this.langage);
            this.$store.dispatch('fundation/changeLang', {lang: this.langage, i18n: this.$i18n});
        },
        logout() {
            this.$store.dispatch('logoutUser');
            this.$router.push({name:'login'});
        },
        openHistoryModal(){
            this.displayHistoryModal = true;
        },
        closeHistoryModal(){
            this.displayHistoryModal = false;
        },
    }
};
</script>

<style lang="less">
@import '../../less/variables';
.lang_logout {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    width: 100%;
    text-align: center;
    padding: 20px 20px 0 0;
    .back-to-portal a{
        color: @color-1;
        line-height: 30px;
        padding-right: 30px;
    }
    .langage {
        margin: -5px 20px 8px 0;
        width: 50px;
        input {
            padding: 0 5px;
            border-top: none;
            border-left: none;
            border-right: none;
            border-radius: 0;
            border-color: @color-1;
            background: transparent;
            &:focus {
                border-color: @color-1 !important;
            }

        }
    }
    .logout {
        height: 20px;
        cursor: pointer;
        margin: -5px 0 8px 0;
        width: 20px;
        fill: @color-1;
    }
    .user-options {
        i {
            font-size: 25px;
            margin: 0 20px 6px 0;
            color: @color-1;
        }
        i:hover {
            cursor: pointer;
        }
    }
}
.el-popover {
    .menu-item {
        width: 100%;
        text-align: center;
        text-transform: uppercase;
    }
    .menu-item:hover {
        cursor: pointer;
        color: @color-1;
    }
}

.row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 20px 5% 0;
    width: 90%;
    align-items: center;
    .logos {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        flex-wrap: wrap;
        width: 35%;
        align-items: center;
        .col3 {
            margin-bottom: 40px;
            .app-title {
                margin: 0;
                display: block;
                text-transform: uppercase;
                color: @color-1;
                font-weight: bold;
                text-align: center;
                @media @desktop {
                    font-size: 28px;
                }
            }
            .edf-logo {

                margin: -12px 0 0 0 !important;
                img {
                    display: block;
                    width: 116px;
                    margin: 0;
                }
            }
        }
    }
    .linksV2 {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        flex-wrap: wrap;
        align-items: center;
        text-align: center;
        padding: 0;
        list-style: none;
        margin-bottom: 40px;
        width: 50%;
        .el-input__inner {
            color: #c2c6ce;
        }
        .el-button {
            text-transform: uppercase;
            font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
        }
        .el-button:focus, .el-button:hover {
            background-color: rgb(245, 255, 236);
            color: @color-text;
        }
        .simulationIndicator {
            margin-left: 10px;
            .el-badge__content {
                background-color: #27316D;
                border: none;
                border-radius: 20px;
                height: 25px;
                width: auto;
                text-align: center;
                padding-top: 4px;
                font-size: 15px;
            }
        }
        a {
            text-decoration: none !important;
            margin: 0 !important;
            button {
                color: @color-text;
                border: none;
                transition-delay: 0;
                transition-duration: 0.4s;
                transition-property: all;
            }
        }


    }
}
.history-button{
    color: #C4D600 !important;
    span{
        font-size: 12px;
        color: #C4D600 !important;
        font-weight: 600;
        text-transform: lowercase;
    }
    margin-left: 0.2rem;
}
.history-button::first-letter {
    text-transform: uppercase;
}
.history-button:hover{
    background-color: none;
}
.history-loader{
    margin-left: 3rem;
    color: #C4D600 !important;
}
.history-dialog{
    .el-dialog{
        &__body{
            padding-top: 0;
            text-align: left !important;
            margin-left: 0;
        }
        &__header{
            margin-left: 0;
            margin-right: 0;
            padding-bottom: 0;
        }
        &__title{
            font-weight: bold;
            color: #C4D600 !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/top-nav.vue